// src/hooks/useUser.js
// Gère le document plat users/{uid} : email, name, alertDays, lastAlert
import { useState, useEffect, useCallback } from 'react';
import { subscribeUser, saveUserData } from '../lib/firebase';

const DEFAULTS = {
  email:      '',
  name:       '',
  alertDays:  '7',
  lastAlert:  null,
};

export function useUser(uid) {
  const [userData, setUserData] = useState(DEFAULTS);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    if (!uid) return;
    setLoading(true);
    const unsub = subscribeUser(uid, data => {
      setUserData(data ? { ...DEFAULTS, ...data } : DEFAULTS);
      setLoading(false);
    });
    return unsub;
  }, [uid]);

  const save = useCallback(async (patch) => {
    if (!uid) return;
    const merged = { ...userData, ...patch };
    setUserData(merged);
    await saveUserData(uid, patch);
  }, [uid, userData]);

  return { userData, loading, save };
}
